import styles from "./styles.module.scss";
import { useMemo, useState } from "react";
import classNames from "classnames";
import BankInformation from "./components/BankInformation";
import DocumentationInformation from "./components/DocumentationInformation";
import TiersInformation from "./components/TiersInformation";
import UsersInformation from "./components/UsersInformation";
import ClientsInformation from "./components/ClientsInformation";
import { useOrganisationStore } from "../../../providers/organisation/organisation.provider";
import { useTranslation } from "react-i18next";

const BusinessSettings = () => {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const organization = useOrganisationStore(
    (state) => state.selectedOrganisation
  );

  const list = useMemo(() => {
    return [
      {
        id: 0,
        title: "إدارة المستخدمين",
      },
      {
        id: 1,
        title: "بيانات الحساب البنكي",
      },
      {
        id: 2,
        title: "الملفات والتوثيق",
      },
      {
        id: 3,
        title: "اتفاقية وفّي",
      },
      {
        id: 4,
        title: t("lbl_api_clients"),
      },
    ];
  }, [t]);

  return (
    <div className={styles.container}>
      <h1 className={styles.topHeader}>{t("lbl_settings")}</h1>
      <div className={styles.tabContainer}>
        {list?.map((listItem) => (
          <li
            onClick={() => setSelectedIndex(listItem?.id)}
            key={listItem?.title}
            className={classNames(
              styles.listItem,
              {
                [styles.listItemSelected]: listItem?.id === selectedIndex,
              },
              { [styles.firstItem]: listItem?.id === 0 },
              {
                [styles.lastItem]:
                  listItem?.id === list?.[list?.length - 1]?.id,
              }
            )}>
            {listItem?.title}
          </li>
        ))}
      </div>
      {selectedIndex === 0 && <UsersInformation organization={organization} />}
      {selectedIndex === 1 && <BankInformation organization={organization} />}
      {selectedIndex === 2 && (
        <DocumentationInformation organization={organization} />
      )}
      {selectedIndex === 3 && (
        <TiersInformation organization={organization} isEditable />
      )}
      {selectedIndex === 4 && (
        <ClientsInformation organization={organization} />
      )}
    </div>
  );
};

export default BusinessSettings;
